$ = require('jquery')

exports.init = (options) ->
	realclick = true

	$(document)
		# box accordion
		.on('click', '.box-accordion__title__link', (e) ->
			e.preventDefault()

			$this = $(@)
			$closest = $this.closest('.box-accordion')
			$item = $this.closest('.box-accordion__item')
			$itemBox = $item.find('.box-accordion__box')
			$itemOther = $item.siblings('.box-accordion__item')
			id = '#' + $itemBox.attr('id')

			if $item.hasClass('is-open') and realclick
				# history
				if $closest.hasClass('with-history') and realclick
					history.pushState(null, null, window.location.pathname)

				$itemBox.slideUp(->
					$item.removeClass('is-open')
				)
			else
				$itemOther.find('.box-accordion__box').slideUp(->
					$itemOther.removeClass('is-open')
				)

				$itemBox.slideDown(->
					$item.addClass('is-open')

					if $item.offset().top < $(window).scrollTop()
						$('body, html').animate(
							scrollTop: $item.offset().top
						250)

					# history
					if $closest.hasClass('with-history') and realclick
						history.pushState(null, null, id);
				)
		)


	# # hash change
	$(window).on('hashchange', ->
		id = ''
		realclick = false

		if location.hash != ''
			$('.box-accordion.with-history .box-accordion__title__link[href=' + location.hash + ']').click()
		# else
		# 	$('.box-accordion__box').slideUp(->
		# 		$('.box-accordion__item').removeClass('is-open')
		# 	)

		realclick = true
	)



/** WEBPACK FOOTER **
 ** ./src/js/components/accordion.coffee
 **/